import React from "react";
import {Modal2} from "../modal";
import {Spinner} from "../../funcs/utils";
import {sprintf} from "sprintf-js";
import {adminUpdateProxyOnboarding} from "./actions";

const STATE = {
  PENDING: "PENDING",
  NO_UPDATES: "NO_UPDATES",
  UPDATED: "UPDATED",
  ERROR: "ERROR",
}


const Updating = items => {

  const button_list = [
    {
      label: <Spinner/>,
    }
  ];

  const item_divs = items.map((item, index) => {
    return (
      <div key={index} style={{display: "flex"}}>
        <div style={{ flex: "1" }}>{item.username}</div>
        <div>{sprintf("%04d", item.index)}</div>
      </div>
    )
  })
  return (
    <Modal2
      header={"Update Proxy"}
      buttonList={button_list}>
      <div>
        <div style={{fontSize: "1.2rem"}}>
          Updating Onboarding Proxy status for:
        </div>
        <div style={{height: "1rem"}}/>
        <div>
          { item_divs }
        </div>
      </div>
    </Modal2>
  );
}

const Updated = (component, items) => {

  const button_list = [
    {
      label: "Ok",
      cb: () => {
        component.setState({
          update_proxy_items: null,
        })
      }
    }
  ];

  const item_divs = items.map((item, index) => {
    return (
      <div key={index} style={{display: "flex"}}>
        <div style={{ flex: "1" }}>{item.username}</div>
        <div>{sprintf("%04d", item.index)}</div>
      </div>
    )
  })
  return (
    <Modal2
      header={"Update Proxy"}
      buttonList={button_list}>
      <div>
        <div style={{fontSize: "1.2rem"}}>
          Updating Onboarding Proxy status for:
        </div>
        <div style={{height: "1rem"}}/>
        <div>
          { item_divs }
        </div>
      </div>
    </Modal2>
  );
}

const Error = component => {

  const button_list = [
    {
      label: "Ok",
      cb: () => {
        component.setState({
          update_proxy_items: null,
        })
      }
    }
  ]
  return (
    <Modal2
      header={"Update Proxy"}
      buttonList={button_list}>
      <div align={"center"} style={{fontSize: "1.2rem"}}>
        There was an error
      </div>
    </Modal2>
  );
}

const NoUpdates = (component, items) => {

  const button_list = [
    {
      label: "Ok",
      cb: () => {
        component.setState({
          update_proxy_items: null,
        })
      }
    }
  ];

  const item_divs = items.map((item, index) => {
    return (
      <div key={index} style={{display: "flex"}}>
        <div style={{ flex: "1" }}>{item.username}</div>
        <div>{sprintf("%04d", item.index)}</div>
      </div>
    )
  })

  return (
    <Modal2
      header={"Update Proxy"}
      buttonList={button_list}>
      <div align={"center"} style={{fontSize: "1.2rem"}}>
        No Updates
      </div>
      <div style={{height: "1rem"}}/>
      <div>
        { item_divs }
      </div>
    </Modal2>
  );
}

const UpdateProxyDialog = props => {
  const component = props.component;
  const state = component.state.update_proxy_items.state;

  if (state === STATE.PENDING) {
    return Updating(component.state.update_proxy_items.items);
  } else if (state === STATE.ERROR) {
    return Error(component);
  } else if (state === STATE.NO_UPDATES) {
    return NoUpdates(component, component.state.update_proxy_items.items);
  } else if (state === STATE.UPDATED) {
    return Updated(component, component.state.update_proxy_items.items);
  }
}


const update_proxy_controller = async (component, items) => {

  component.setState({
    update_proxy_items: {
      items,
      state: STATE.PENDING,
    }
  });
  const token = component.props.token;


  const resp = await adminUpdateProxyOnboarding(token, items);
  if (resp.status === "ERROR") {
    component.setState({
      update_proxy_items: {
        state: STATE.ERROR,
      }
    });
    return;
  }

  const updated_items = resp.payload.updated_items;

  if (updated_items.length === 0) {
    component.setState({
      update_proxy_items: {
        state: STATE.NO_UPDATES,
        items: component.state.update_proxy_items.items,
      }
    });
    return;
  }

  component.setState({
    update_proxy_items: {
      state: STATE.UPDATED,
      items: updated_items,
    }
  })

}

export { update_proxy_controller, UpdateProxyDialog };
